<script>
import { endsWith } from "../../utils/helper";

export default {
  name: "Columns",
  render: function(createElement) {
    return createElement(
      "div",
      { class: { columns: true } },
      this.$slots.default
        .filter(item => item.tag)
        .map(item => {
          return endsWith(item.tag, "Column")
            ? item
            : createElement("div", { class: { column: true } }, [item]);
        })
    );
  }
};
</script>
